
import * as Yup from 'yup'

import { QuotationStatusEnum } from '@/types'

export const availableQuotationStatuses: Record<
  QuotationStatusEnum,
  (keyof typeof QuotationStatusEnum)[]
> = {
  created: ['pending', 'cancelled'],
  pending: ['pending_approval', 'ready', 'cancelled'],
  pending_approval: ['pending', 'ready', 'cancelled'],
  ready: ['pending_approval', 'active', 'cancelled'],
  active: ['accepted', 'rejected', 'cancelled'],
  accepted: ['cancelled'],
  cancelled: [],
  rejected: [],
  expired: [],
}

export const schemaMapsUrl = (t: (key: string) => string) => ({
  mapsUrl: Yup.string().required(t('requiredMessage')),
})

export const checkExpiresAt = (expiresAt?: string) => {
  if (!expiresAt) return true

  const expires = new Date(expiresAt)
  const now = new Date()
  const diff = expires.getTime() - now.getTime()
  const oneDay = 24 * 60 * 60 * 1000

  return diff < oneDay

}